export class StringHelper {
	/**
	 * Capitalizes the first letter for each word and sets the rest to lowercase
	 * @param str
	 */
	public static toTitleCase(str) {
		return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
	}
}
